import SerialUnitRegisterHelpMdx from "../../help/serial-unit-register.mdx";

export function SerialUnitRegisterHelpPage() {
  return <SerialUnitRegisterHelpMdx />;
}
